module.exports = __webpack_public_path__ + "static/media/29ADMSPC23.4505213c.jpg";